import React from 'react';
import Head from 'next/head';
import { SEARCH_PAGE } from '@core/ui/navigation/constant';

const Canonical = ({ category }) => {
  const _convertToQueryParams = category => {
    return `${process.env.SITE_URL}/${SEARCH_PAGE}/${category}`;
  };

  if (!category) {
    return null;
  }

  return (
    <Head>
      <link rel="canonical" href={_convertToQueryParams(category)} />
    </Head>
  );
};

export default Canonical;
